var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.backgroundURL)?_c('div',{staticClass:"swbg",style:({ backgroundImage: ("url('" + _vm.backgroundURL + "')") })}):_vm._e(),(_vm.showAnimatedBackground)?_c('AnimatedBackground'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }